export const countries = [
  { value: 'AAABritish', label: 'British' },
  { value: 'Afghan', label: 'Afghan' },
  { value: 'Albanian', label: 'Albanian' },
  { value: 'Algerian', label: 'Algerian' },
  { value: 'American', label: 'American' },
  { value: 'Andorran', label: 'Andorran' },
  { value: 'Angolan', label: 'Angolan' },
  { value: 'Anguillan', label: 'Anguillan' },
  { value: 'Argentine', label: 'Argentine' },
  { value: 'Armenian', label: 'Armenian' },
  { value: 'Australian', label: 'Australian' },
  { value: 'Austrian', label: 'Austrian' },
  { value: 'Azerbaijani', label: 'Azerbaijani' },
  { value: 'Bahamian', label: 'Bahamian' },
  { value: 'Bahraini', label: 'Bahraini' },
  { value: 'Bangladeshi', label: 'Bangladeshi' },
  { value: 'Barbadian', label: 'Barbadian' },
  { value: 'Belarusian', label: 'Belarusian' },
  { value: 'Belgian', label: 'Belgian' },
  { value: 'Belizean', label: 'Belizean' },
  { value: 'Beninese', label: 'Beninese' },
  { value: 'Bermudian', label: 'Bermudian' },
  { value: 'Bhutanese', label: 'Bhutanese' },
  { value: 'Bolivian', label: 'Bolivian' },
  { value: 'Botswanan', label: 'Botswanan' },
  { value: 'Brazilian', label: 'Brazilian' },
  { value: 'British', label: 'British' },
  { value: 'British Virgin Islander', label: 'British Virgin Islander' },
  { value: 'Bruneian', label: 'Bruneian' },
  { value: 'Bulgarian', label: 'Bulgarian' },
  { value: 'Burkinan', label: 'Burkinan' },
  { value: 'Burmese', label: 'Burmese' },
  { value: 'Burundian', label: 'Burundian' },
  { value: 'Cambodian', label: 'Cambodian' },
  { value: 'Cameroonian', label: 'Cameroonian' },
  { value: 'Canadian', label: 'Canadian' },
  { value: 'Cape Verdean', label: 'Cape Verdean' },
  { value: 'Cayman Islander', label: 'Cayman Islander' },
  { value: 'Central African', label: 'Central African' },
  { value: 'Chadian', label: 'Chadian' },
  { value: 'Chilean', label: 'Chilean' },
  { value: 'Chinese', label: 'Chinese' },
  { value: 'Citizen of Antigua and Barbuda', label: 'Citizen of Antigua and Barbuda' },
  { value: 'Citizen of Bosnia and Herzegovina', label: 'Citizen of Bosnia and Herzegovina' },
  { value: 'Citizen of Guinea-Bissau', label: 'Citizen of Guinea-Bissau' },
  { value: 'Citizen of Kiribati', label: 'Citizen of Kiribati' },
  { value: 'Citizen of Seychelles', label: 'Citizen of Seychelles' },
  { value: 'Citizen of the Dominican Republic', label: 'Citizen of the Dominican Republic' },
  { value: 'Citizen of Vanuatu', label: 'Citizen of Vanuatu' },
  { value: 'Colombian', label: 'Colombian' },
  { value: 'Comoran', label: 'Comoran' },
  { value: 'Congolese (Congo)', label: 'Congolese (Congo)' },
  { value: 'Congolese (DRC)', label: 'Congolese (DRC)' },
  { value: 'Cook Islander', label: 'Cook Islander' },
  { value: 'Costa Rican', label: 'Costa Rican' },
  { value: 'Croatian', label: 'Croatian' },
  { value: 'Cuban', label: 'Cuban' },
  { value: 'Cymraes', label: 'Cymraes' },
  { value: 'Cymro', label: 'Cymro' },
  { value: 'Cypriot', label: 'Cypriot' },
  { value: 'Czech', label: 'Czech' },
  { value: 'Danish', label: 'Danish' },
  { value: 'Djiboutian', label: 'Djiboutian' },
  { value: 'Dominican', label: 'Dominican' },
  { value: 'Dutch', label: 'Dutch' },
  { value: 'East Timorese', label: 'East Timorese' },
  { value: 'Ecuadorean', label: 'Ecuadorean' },
  { value: 'Egyptian', label: 'Egyptian' },
  { value: 'Emirati', label: 'Emirati' },
  { value: 'English', label: 'English' },
  { value: 'Equatorial Guinean', label: 'Equatorial Guinean' },
  { value: 'Eritrean', label: 'Eritrean' },
  { value: 'Estonian', label: 'Estonian' },
  { value: 'Ethiopian', label: 'Ethiopian' },
  { value: 'Faroese', label: 'Faroese' },
  { value: 'Fijian', label: 'Fijian' },
  { value: 'Filipino', label: 'Filipino' },
  { value: 'Finnish', label: 'Finnish' },
  { value: 'French', label: 'French' },
  { value: 'Gabonese', label: 'Gabonese' },
  { value: 'Gambian', label: 'Gambian' },
  { value: 'Georgian', label: 'Georgian' },
  { value: 'German', label: 'German' },
  { value: 'Ghanaian', label: 'Ghanaian' },
  { value: 'Gibraltarian', label: 'Gibraltarian' },
  { value: 'Greek', label: 'Greek' },
  { value: 'Greenlandic', label: 'Greenlandic' },
  { value: 'Grenadian', label: 'Grenadian' },
  { value: 'Guamanian', label: 'Guamanian' },
  { value: 'Guatemalan', label: 'Guatemalan' },
  { value: 'Guinean', label: 'Guinean' },
  { value: 'Guyanese', label: 'Guyanese' },
  { value: 'Haitian', label: 'Haitian' },
  { value: 'Honduran', label: 'Honduran' },
  { value: 'Hong Konger', label: 'Hong Konger' },
  { value: 'Hungarian', label: 'Hungarian' },
  { value: 'Icelandic', label: 'Icelandic' },
  { value: 'Indian', label: 'Indian' },
  { value: 'Indonesian', label: 'Indonesian' },
  { value: 'Iranian', label: 'Iranian' },
  { value: 'Iraqi', label: 'Iraqi' },
  { value: 'Irish', label: 'Irish' },
  { value: 'Israeli', label: 'Israeli' },
  { value: 'Italian', label: 'Italian' },
  { value: 'Ivorian', label: 'Ivorian' },
  { value: 'Jamaican', label: 'Jamaican' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Jordanian', label: 'Jordanian' },
  { value: 'Kazakh', label: 'Kazakh' },
  { value: 'Kenyan', label: 'Kenyan' },
  { value: 'Kittitian', label: 'Kittitian' },
  { value: 'Kosovan', label: 'Kosovan' },
  { value: 'Kuwaiti', label: 'Kuwaiti' },
  { value: 'Kyrgyz', label: 'Kyrgyz' },
  { value: 'Lao', label: 'Lao' },
  { value: 'Latvian', label: 'Latvian' },
  { value: 'Lebanese', label: 'Lebanese' },
  { value: 'Liberian', label: 'Liberian' },
  { value: 'Libyan', label: 'Libyan' },
  { value: 'Liechtenstein citizen', label: 'Liechtenstein citizen' },
  { value: 'Lithuanian', label: 'Lithuanian' },
  { value: 'Luxembourger', label: 'Luxembourger' },
  { value: 'Macanese', label: 'Macanese' },
  { value: 'Macedonian', label: 'Macedonian' },
  { value: 'Malagasy', label: 'Malagasy' },
  { value: 'Malawian', label: 'Malawian' },
  { value: 'Malaysian', label: 'Malaysian' },
  { value: 'Maldivian', label: 'Maldivian' },
  { value: 'Malian', label: 'Malian' },
  { value: 'Maltese', label: 'Maltese' },
  { value: 'Marshallese', label: 'Marshallese' },
  { value: 'Martiniquais', label: 'Martiniquais' },
  { value: 'Mauritanian', label: 'Mauritanian' },
  { value: 'Mauritian', label: 'Mauritian' },
  { value: 'Mexican', label: 'Mexican' },
  { value: 'Micronesian', label: 'Micronesian' },
  { value: 'Moldovan', label: 'Moldovan' },
  { value: 'Monegasque', label: 'Monegasque' },
  { value: 'Mongolian', label: 'Mongolian' },
  { value: 'Montenegrin', label: 'Montenegrin' },
  { value: 'Montserratian', label: 'Montserratian' },
  { value: 'Moroccan', label: 'Moroccan' },
  { value: 'Mosotho', label: 'Mosotho' },
  { value: 'Mozambican', label: 'Mozambican' },
  { value: 'Namibian', label: 'Namibian' },
  { value: 'Nauruan', label: 'Nauruan' },
  { value: 'Nepalese', label: 'Nepalese' },
  { value: 'New Zealander', label: 'New Zealander' },
  { value: 'Nicaraguan', label: 'Nicaraguan' },
  { value: 'Nigerian', label: 'Nigerian' },
  { value: 'Nigerien', label: 'Nigerien' },
  { value: 'Niuean', label: 'Niuean' },
  { value: 'North Korean', label: 'North Korean' },
  { value: 'Northern Irish', label: 'Northern Irish' },
  { value: 'Norwegian', label: 'Norwegian' },
  { value: 'Omani', label: 'Omani' },
  { value: 'Pakistani', label: 'Pakistani' },
  { value: 'Palauan', label: 'Palauan' },
  { value: 'Palestinian', label: 'Palestinian' },
  { value: 'Panamanian', label: 'Panamanian' },
  { value: 'Papua New Guinean', label: 'Papua New Guinean' },
  { value: 'Paraguayan', label: 'Paraguayan' },
  { value: 'Peruvian', label: 'Peruvian' },
  { value: 'Pitcairn Islander', label: 'Pitcairn Islander' },
  { value: 'Polish', label: 'Polish' },
  { value: 'Portuguese', label: 'Portuguese' },
  { value: 'Prydeinig', label: 'Prydeinig' },
  { value: 'Puerto Rican', label: 'Puerto Rican' },
  { value: 'Qatari', label: 'Qatari' },
  { value: 'Romanian', label: 'Romanian' },
  { value: 'Russian', label: 'Russian' },
  { value: 'Rwandan', label: 'Rwandan' },
  { value: 'Salvadorean', label: 'Salvadorean' },
  { value: 'Sammarinese', label: 'Sammarinese' },
  { value: 'Samoan', label: 'Samoan' },
  { value: 'Sao Tomean', label: 'Sao Tomean' },
  { value: 'Saudi Arabian', label: 'Saudi Arabian' },
  { value: 'Scottish', label: 'Scottish' },
  { value: 'Senegalese', label: 'Senegalese' },
  { value: 'Serbian', label: 'Serbian' },
  { value: 'Sierra Leonean', label: 'Sierra Leonean' },
  { value: 'Singaporean', label: 'Singaporean' },
  { value: 'Slovak', label: 'Slovak' },
  { value: 'Slovenian', label: 'Slovenian' },
  { value: 'Solomon Islander', label: 'Solomon Islander' },
  { value: 'Somali', label: 'Somali' },
  { value: 'South African', label: 'South African' },
  { value: 'South Korean', label: 'South Korean' },
  { value: 'South Sudanese', label: 'South Sudanese' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Sri Lankan', label: 'Sri Lankan' },
  { value: 'St Helenian', label: 'St Helenian' },
  { value: 'St Lucian', label: 'St Lucian' },
  { value: 'Stateless', label: 'Stateless' },
  { value: 'Sudanese', label: 'Sudanese' },
  { value: 'Surinamese', label: 'Surinamese' },
  { value: 'Swazi', label: 'Swazi' },
  { value: 'Swedish', label: 'Swedish' },
  { value: 'Swiss', label: 'Swiss' },
  { value: 'Syrian', label: 'Syrian' },
  { value: 'Taiwanese', label: 'Taiwanese' },
  { value: 'Tajik', label: 'Tajik' },
  { value: 'Tanzanian', label: 'Tanzanian' },
  { value: 'Thai', label: 'Thai' },
  { value: 'Togolese', label: 'Togolese' },
  { value: 'Tongan', label: 'Tongan' },
  { value: 'Trinidadian', label: 'Trinidadian' },
  { value: 'Tristanian', label: 'Tristanian' },
  { value: 'Tunisian', label: 'Tunisian' },
  { value: 'Turkish', label: 'Turkish' },
  { value: 'Turkmen', label: 'Turkmen' },
  { value: 'Turks and Caicos Islander', label: 'Turks and Caicos Islander' },
  { value: 'Tuvaluan', label: 'Tuvaluan' },
  { value: 'Ugandan', label: 'Ugandan' },
  { value: 'Ukrainian', label: 'Ukrainian' },
  { value: 'Uruguayan', label: 'Uruguayan' },
  { value: 'Uzbek', label: 'Uzbek' },
  { value: 'Vatican citizen', label: 'Vatican citizen' },
  { value: 'Venezuelan', label: 'Venezuelan' },
  { value: 'Vietnamese', label: 'Vietnamese' },
  { value: 'Vincentian', label: 'Vincentian' },
  { value: 'Wallisian', label: 'Wallisian' },
  { value: 'Welsh', label: 'Welsh' },
  { value: 'Yemeni', label: 'Yemeni' },
  { value: 'Zambian', label: 'Zambian' },
  { value: 'Zimbabwean', label: 'Zimbabwean' },
];
